import React from 'react'
import ReactDOM from 'react-dom'
import Toast from './Toast'

// 创建一个提示dom
const createNotification = () => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const notification = ReactDOM.hydrate(<Toast />, div)
  return {
    addNotice(notice) {
      return notification.addNotice(notice)
    },
    destroy() {
      ReactDOM.unmountComponentAtNode(div)
      document.body.removeChild(div)
    },
  }
}

const notice = ({
  type,
  title,
  description,
  duration = 2000,
  onClose,
  theme,
  position,
}) => {
  const notification = createNotification()
  return notification.addNotice({
    type,
    title,
    description,
    duration,
    onClose,
    theme,
    position,
  })
}

// 提示框类型
export default {
  info(props = {}) {
    return notice({ type: 'info', ...props })
  },
  success(props = {}) {
    return notice({ type: 'success', ...props })
  },
  error(props = {}) {
    return notice({ type: 'error', ...props })
  },
  warning(props = {}) {
    return notice({ type: 'warning', ...props })
  },
}
